import { GlExperimentBadge, GlLink, GlIcon, GlModalDirective, GlPopover, GlSprintf, GlButton } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { s__ } from '~/locale';
import PageHeading from '~/vue_shared/components/page_heading.vue';
import LinkToDashboardModal, { LINK_TO_DASHBOARD_MODAL_ID } from '../../../analytics/analytics_dashboards/link_to_dashboards/link_to_dashboards_modal.vue?vue3';
import { TRACKING_ACTION_CLICK_DASHBOARD_LINK, TRACKING_LABEL_AI_CATALOG_HEADER } from 'ee/analytics/analytics_dashboards/link_to_dashboards/tracking';
import { AI_IMPACT_DASHBOARD } from 'ee/analytics/analytics_dashboards/constants';
import { DOCS_URL } from '~/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import AiCatalogNavTabs from './ai_catalog_nav_tabs.vue?vue3';
import AiCatalogNavActions from './ai_catalog_nav_actions.vue?vue3';
export default {
    name: 'AiCatalogListHeader',
    components: {
        GlExperimentBadge,
        GlLink,
        GlIcon,
        AiCatalogNavTabs,
        AiCatalogNavActions,
        PageHeading,
        LinkToDashboardModal,
        GlPopover,
        GlSprintf,
        GlButton
    },
    directives: {
        GlModal: GlModalDirective
    },
    mixins: [
        glSlotsMixin
    ],
    inject: {
        isGlobalNamespace: {},
        aiImpactDashboardEnabled: {
            default: false
        },
        aiImpactDashboardPath: {
            default: null
        },
        showLegalDisclaimer: {
            default: false
        }
    },
    props: {
        heading: {
            type: String,
            required: false,
            default: undefined
        },
        canAdmin: {
            type: Boolean,
            required: false,
            default: false
        },
        canCreate: {
            type: Boolean,
            required: false,
            default: false
        },
        newButtonVariant: {
            type: String,
            required: false,
            default: undefined
        },
        isExperiment: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        title () {
            return this.heading || s__('AICatalog|AI Catalog');
        },
        aiImpactDashboardDocsLink () {
            return `${DOCS_URL}/user/analytics/duo_and_sdlc_trends/`;
        },
        aiImpactDashboardLinkAttrs () {
            return {
                'data-testid': 'ai-impact-dashboard-link',
                'data-track-action': this.$options.TRACKING_ACTION_CLICK_DASHBOARD_LINK,
                'data-track-label': this.$options.TRACKING_LABEL_AI_CATALOG_HEADER
            };
        },
        badgeType () {
            if (this.isExperiment) {
                return 'experiment';
            }
            return '';
        },
        shouldShowLinkToDashboardsModal () {
            // Show modal when dashboard path is unavailable (path only available in project/group scope, not global scope, e.g., /explore/ai-catalog/agents)
            return this.aiImpactDashboardEnabled && !this.aiImpactDashboardPath;
        },
        hasDashboardLinkWithActions () {
            return !this.isGlobalNamespace && this.canAdmin && this.aiImpactDashboardEnabled;
        }
    },
    LINK_TO_DASHBOARD_MODAL_ID,
    TRACKING_ACTION_CLICK_DASHBOARD_LINK,
    TRACKING_LABEL_AI_CATALOG_HEADER,
    AI_IMPACT_DASHBOARD,
    AI_IMPACT_DASHBOARD_POPOVER_TARGET_ID: uniqueId('dashboard-link'),
    i18n: {
        legalDisclaimer: s__('AICatalog|This catalog contains third-party content that may be subject to additional terms. GitLab does not control or assume liability for third-party content.'),
        aiImpactDashboardCTA: s__('AICatalog|Explore your GitLab Duo and SDLC trends')
    }
};
